/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbTimepickerModule,
} from '@nebular/theme';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireModule } from '@angular/fire';
import { OAuthModule,OAuthStorage } from 'angular-oauth2-oidc';

import { environment } from '../environments/environment';
import { SignaturePadModule } from 'angular2-signaturepad';
import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';


export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    return super.parse(url.toLowerCase());
  }
}

export function storageFactory() : OAuthStorage {
  return localStorage
}


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbTimepickerModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    AngularFireMessagingModule,
    SignaturePadModule,
    AngularFireModule.initializeApp(environment.firebase),
    OAuthModule.forRoot(
      {
        resourceServer: {
          allowedUrls: [environment.apiUrl, environment.notificationUrl],
          sendAccessToken: true
        }
      }
    ),
    PdfViewerModule,
    DragDropModule,
  ],
  bootstrap: [AppComponent],
  providers: [{
    provide: UrlSerializer,
    useClass: LowerCaseUrlSerializer
  },
  {
    provide: OAuthStorage,
    useFactory: storageFactory
  }
  ]
})
export class AppModule {
}
